import { render, staticRenderFns } from "./AccisureSmsCustomerForm.vue?vue&type=template&id=c5d65fb8&scoped=true"
import script from "./AccisureSmsCustomerForm.vue?vue&type=script&lang=js"
export * from "./AccisureSmsCustomerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d65fb8",
  null
  
)

export default component.exports